// Opportunities (Agent 5D, Runde 5): Pipeline-Board und Liste (O-01 bis O-14), Anlegen und Ändern (O-17, O-18). Unterrouten:
//   /opportunities          Pipeline (Board, Karten ziehen = Statuswechsel)
//   /opportunities/liste    Liste (Tabelle)
// Bausteine in `src/opportunities/`, Client `api/opportunities.ts`, Backend `routers/opportunities.py` (API.md 20.5).
// Opportunities eines Leads stehen weiter auf der Lead-Seite; der Dialog `OpportunityDialog` aus `src/opportunities/`
// lässt sich dort einsetzen (Wunsch in AENDERUNGSWUENSCHE.md).
import { Navigate, Route, Routes } from "react-router-dom";
import { BoardSeite } from "../opportunities/BoardSeite";
import { ListeSeite } from "../opportunities/ListeSeite";

export default function Opportunities() {
  return (
    <Routes>
      <Route index element={<BoardSeite />} />
      <Route path="liste" element={<ListeSeite />} />
      <Route path="*" element={<Navigate to="/opportunities" replace />} />
    </Routes>
  );
}
